import React from "react";
import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from "@/components/ui/resizable"
import { Header } from "./Header"
import { Toolbar } from "./Toolbar"
import { FilePanel } from "../FilePanel/FilePanel"
import { LogPanel } from "../LogPanel/LogPanel"
import { StatusBar } from "./StatusBar"
import { BatchRenameDialog } from "../Rename/BatchRenameDialog"

export function MainLayout() {
  const [isRenameOpen, setIsRenameOpen] = React.useState(false);

  return (
    <div className="h-screen flex flex-col bg-background text-foreground overflow-hidden">
      <Header />
      <Toolbar onRenameClick={() => setIsRenameOpen(true)} />
      
      <ResizablePanelGroup direction="vertical" className="flex-1">
        {/* Main Content Area */}
        <ResizablePanel defaultSize={70} minSize={30}>
          <ResizablePanelGroup direction="horizontal">
            {/* Left Panel */}
            <ResizablePanel defaultSize={50} minSize={20}>
              <FilePanel side="left" />
            </ResizablePanel>
            
            <ResizableHandle withHandle />
            
            {/* Right Panel */}
            <ResizablePanel defaultSize={50} minSize={20}>
              <FilePanel side="right" />
            </ResizablePanel>
          </ResizablePanelGroup>
        </ResizablePanel>
        
        <ResizableHandle withHandle />
        
        {/* Log Panel */}
        <ResizablePanel defaultSize={20} minSize={10} maxSize={50}>
          <LogPanel />
        </ResizablePanel>
      </ResizablePanelGroup>
      
      <StatusBar />
      <BatchRenameDialog open={isRenameOpen} onOpenChange={setIsRenameOpen} />
    </div>
  )
}
